import { effect, stop } from '@vue/reactivity'
import { evaluateInScope } from '../component/utils'
import qvTransition from './qv-transition.js'

export default {

    signature: 'qv-show',

    handle(node, scope) {

        if (node.nodeType !== Node.ELEMENT_NODE) {
            return null
        }

        if (!node.hasAttribute(this.signature)) {
            return null
        }

        if (node.hasAttribute('qv-for')) {
            return null
        }

        // If element has transition direction, we return early, as the transition directive will handle it
        if (qvTransition.shouldTransition(node)) {
            return null
        }

        const expression = node.getAttribute(this.signature)

        if (!node._originalDisplay) {
            node._originalDisplay = node.style.display !== 'none' ? node.style.display : ''
        }

        const runner = effect(() => {

            const condition = evaluateInScope(expression, scope)

            if (condition) {

                if (node._originalDisplay !== '') {
                    node.style.display = node._originalDisplay
                } else {
                    node.style.removeProperty('display')
                }

            } else {
                node.style.display = 'none'
            }

        })

        return () => {
            stop(runner)
        }

    },

}
